import { HandleType, Position } from "reactflow";
import { HandleId } from "../Handle/types.d";

export type ConditionHandleProps = {
    handleId?: string;
    isActive?: boolean;
    activeColor?: string;
    type: HandleType;
    position?: Position;
    left?: number | string;
    right?: number | string;
    top?: number | string;
};

export type UseConditionHandleProps = Pick<
    ConditionHandleProps,
    "handleId" | "isActive" | "activeColor" | "type" | "position"
>;

export const DEFAULT_ACTIVE_COLOR = "#3650DE";

export const INVALID_SOURCE_HANDLES: HandleId[] = [
    HandleId.Global,
    HandleId.OutputFlow,
    HandleId.ConditionHandle,
    HandleId.OutputHandle,
];

export const DASHED_BORDER = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%23667085FF' stroke-width='3' stroke-dasharray='30%25%2c 13%25' stroke-dashoffset='86' stroke-linecap='butt'/%3e%3c/svg%3e")`;
